/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import FormFader from "@/src/components/Form/Common/Fader/FormFader";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import FormSubmit from "@/src/components/Form/Common/FormSubmit/FormSubmit";
import FamilyIcon from "@/src/assets/icons/generic/toggleable/IconFamilyDetailed";
import StrollerIcon from "@/src/assets/icons/familyLaw/toggleable/IconStroller";
import QuestionMarkIcon from "@/src/assets/icons/common/toggleable/IconQuestionmark";
import { useForm } from "@/src/provider/Form/FormProvider";
import Group from "@/src/components/Wizard/Group";
import { requiredValidator } from "@/src/services/validationRules";
import Typography from "@mui/material/Typography";
import FormSubmitProps from "@/src/types/FormSubmitProps";
import wizardStyle from "@/src/components/Form/wizardStyle";
import { Box } from "@mui/material";

type AlimonyChoiceProps = { submitProps: FormSubmitProps };

export default function AlimonyChoice({ submitProps }: AlimonyChoiceProps) {
  const { handleSubmit } = useForm();

  return (
    <Paper sx={wizardStyle.paper} elevation={4}>
      <FormFader>
        <Box component={"form"} sx={{ ...wizardStyle.applicationForm, ...wizardStyle.wizardForm }} onSubmit={handleSubmit}>
          <Typography variant={"h4"} sx={[wizardStyle.headline, { display: { xs: "block", sm: "none" } }]}>
            Meine Analyse
          </Typography>
          <Grid
            container
            sx={{
              justifyContent: "center",
            }}
          >
            <Grid size={12}>
              <Group
                type="radio"
                name="basicChoice"
                question="Wie können wir Ihnen weiterhelfen?"
                options={[
                  {
                    labelText: "Ehegattenunterhalt und Kindesunterhalt berechnen",
                    labelIcon: <FamilyIcon />,
                    labelIconActive: <FamilyIcon active />,
                    value: "complete",
                    optionHintText:
                      "Ich befinde mich in einer Trennungssituation von meinem Ehepartner und möchte wissen, wer an wen Unterhalt zahlen muss und wie viel.",
                  },
                  {
                    labelText: "Nur Kindesunterhalt berechnen",
                    labelIcon: <StrollerIcon />,
                    labelIconActive: <StrollerIcon active />,
                    value: "children",
                    optionHintText:
                      "Ich möchte nur wissen, wer Kindesunterhalt zahlen muss und wie viel. In der Berechnung soll also kein Ehegattenunterhalt berücksichtigt werden.",
                  },
                  {
                    labelText: "Andere Frage im Bereich Unterhalt",
                    labelIcon: <QuestionMarkIcon />,
                    labelIconActive: <QuestionMarkIcon active />,
                    value: "other",
                    optionHintText: "Ich benötige keine Berechnung, sondern habe ein anderes Anliegen.",
                  },
                ]}
                validators={[requiredValidator("Bitte wählen Sie eine der angezeigten Antworten aus")]}
              />
            </Grid>
          </Grid>
          <FormSubmit {...submitProps} />
        </Box>
      </FormFader>
    </Paper>
  );
}
